import React from 'react'
import _ from 'lodash'

import OrderActions from '../../actions/OrderActions.js'

import {Alert, Card, Colors, IconButton, H6, S1, P, Icon, Badge} from '../UI/index.js'
import AddressAttachment from '../addresses/AddressAttachment.js'
import {formSpacing} from '../UI/forms/index.js'
import EditAddress from './EditAddress.js'
import {recipientWishes} from '../../../utils/recipientChoice.js'

class Address extends React.PureComponent {
    constructor(props) {
        super(props)

        this.initialState = {
            hover: false,
            loading: true,
            error: '',
            message: ''
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    // Whether the address is being edited and differs from the saved address, used to warn before closing the order
    hasChanges() {
        const {order, addressIndex} = this.props

        return !!this.state.edit && !!this.editAddress?.state.address && !_.isEqual(this.editAddress.state.address, JSON.parse(JSON.stringify(order.addresses[addressIndex])))
    }

    saveChanges(callback) {
        this.saveCallback = callback
        this.editAddress.save()
    }

    saveAddress(address) {
        const {order, addressIndex} = this.props
        const callback = this.saveCallback
        this.saveCallback = null

        this.setState({hover: false, edit: false, error: ''})

        OrderActions.editAddress(order._id, addressIndex, address, (err, order) => {
            if (err) {
                this.setState({error: err})
            } else {
                this.props.onUpdateOrder(order)
            }

            typeof callback === 'function' && callback(err)
        })
    }

    render() {
        const {hover, edit, error} = this.state
        const {order, addressIndex, addressBook, reseller, disabled, isRetour} = this.props

        // disabled: an address that is no longer part of the order (the original address of a retour), shown read-only
        const address = this.props.address || order.addresses[addressIndex]
        const readOnly = this.props.readOnly || disabled
        const typeColor = disabled ? Colors.grey40 : isRetour ? Colors.retour : Colors[address.type]

        return (
            <div style={{width: '100%', marginBottom: 12}}>

                <Card
                    style={{position: 'relative', display: 'flex', padding: 0, borderRadius: '0px 4px 4px 4px', background: edit || disabled ? Colors.backgroundNeutral2 : Colors.backgroundWhite, opacity: disabled ? 0.7 : 1}}
                >

                    <div style={{position: 'absolute', left: -6, top: 0, height: 36, width: 6, borderRadius: '4px 0px 0px 4px', background: typeColor}} />

                    {!edit &&
                        <div style={{display: 'flex', width: '100%'}}>
                            <div
                                style={{display: 'flex', flex: 1, borderRight: `1px dotted ${Colors.border}`}}
                                onMouseEnter={() => this.setState({hover: true})}
                                onMouseLeave={() => this.setState({hover: false})}
                            >
                                <div style={{flex: 1, padding: 6}}>

                                    <S1 style={{display: 'flex', alignItems: 'center'}}>
                                        <i style={{marginRight: 6, fontSize: 16}} className='mdi mdi-map-marker' />
                                        {`${address.street} ${address.nr}${address.addition}`}
                                    </S1>
                                    <P style={{marginLeft: 25}}>{address.street2}</P>
                                    <P style={{marginLeft: 25, marginBottom: 12}}>{`${address.postalCode} ${address.city} (${address.country})`}</P>

                                    {address.name &&
                                        <P style={{display: 'flex', alignItems: 'center'}}>
                                            <i style={{marginRight: 6, fontSize: 16}} className={address.isBusiness ? 'mdi mdi-store' : address.attention ? 'mdi mdi-home' : 'mdi mdi-account'} />
                                            {address.name}
                                        </P>
                                    }

                                    {address.attention &&
                                        <P style={{display: 'flex', alignItems: 'center'}}>
                                            <i style={{marginRight: 6, fontSize: 16}} className='mdi mdi-account' />
                                            {address.attention}
                                        </P>
                                    }

                                    {address.phone &&
                                        <P style={{display: 'flex', alignItems: 'center'}}>
                                            <i style={{marginRight: 6, fontSize: 16}} className='mdi mdi-phone' />
                                            {address.phone}
                                        </P>
                                    }

                                    {address.email &&
                                        <P style={{display: 'flex', alignItems: 'center'}}>
                                            <i style={{marginRight: 6, fontSize: 16}} className='mdi mdi-at' />
                                            {address.email}
                                        </P>
                                    }

                                    {address.attachments && address.attachments.length > 0 &&
                                        <P style={{display: 'flex', alignItems: 'center'}}>
                                            <AddressAttachment address={address} />
                                        </P>
                                    }
                                </div>

                                <div style={{height: 42, width: 42}}>
                                    {address.type === 'delivery' && hover && !edit && !disabled &&
                                        <IconButton
                                            onClick={() => this.props.onClickPrintLabels(order._id, address.index)}
                                            icon='mdi mdi-printer'
                                        />
                                    }
                                </div>

                                {!readOnly &&
                                    <div style={{height: 42, width: 42}}>
                                        {hover && !edit &&
                                            <IconButton
                                                icon='mdi mdi-pencil'
                                                onClick={() => this.setState({edit: !edit})}
                                            />
                                        }
                                    </div>
                                }
                            </div>

                            <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                <div style={{flex: 1, padding: 6}}>
                                    <S1>{isRetour ? 'Retour' : address.type === 'pickup' ? 'Ophalen' : 'Bezorgen'}{disabled ? ' (originele adres)' : ''}</S1>

                                    <P style={{display: 'flex', alignItems: 'center', marginBottom: 12}}>
                                        <i style={{marginRight: 6, fontSize: 16}} className='mdi mdi-clock-outline' />
                                        {`${address.startTime} - ${address.endTime}`}
                                    </P>

                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        {address.gpsRequired &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-map-marker' />
                                        }
                                        {address.signatureRequired &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-fountain-pen-tip' />
                                        }
                                        {address.nameRequired && !address.signatureRequired &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-signature-text' />
                                        }
                                        {address.signatureNeighbors &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home-edit-outline' />
                                        }
                                        {address.statedAddressOnly &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home' />
                                        }
                                        {address.mailboxDelivery &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-mailbox-open-up' />
                                        }
                                        {address.refrigerated &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-snowflake' />
                                        }
                                        {address.scanRequired &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-barcode-scan' />
                                        }
                                        {address.imageRequired &&
                                            <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-camera' />
                                        }
                                        {address.minimumAge &&
                                            <div style={{fontSize: 14, fontWeight: 500, marginRight: 6}}>{`${address.minimumAge}+`}</div>
                                        }
                                        {address.idCheck &&
                                            <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-card-account-details-outline' />
                                        }
                                        {address.verificationCode &&
                                            <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-shield-key-outline' />
                                        }
                                    </div>

                                    {address.customOptions?.length > 0 && (
                                        <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8, marginBottom: 8}}>
                                            {address.customOptions.map((optionId) => {
                                                const option = reseller.settings.orders.customOptions?.find((option) => option.id === optionId)

                                                if (!option) {
                                                    return null
                                                }

                                                return (
                                                    <Badge key={optionId} color={option.color}>
                                                        {option.name}
                                                    </Badge>
                                                )
                                            })}
                                        </div>
                                    )}

                                    {address.instructions &&
                                        <P style={{display: 'flex', whiteSpace: 'pre-line'}}>
                                            <Icon style={{marginRight: 6, fontSize: 16}} icon='mdi mdi-message-outline' />
                                            {address.instructions}
                                        </P>
                                    }

                                    {recipientWishes(address) &&
                                        <P style={{display: 'flex', whiteSpace: 'pre-line'}} title='Gekozen door de ontvanger op de Track & Trace pagina'>
                                            <Icon style={{marginRight: 6, fontSize: 16}} icon='mdi mdi-account-voice' />
                                            {recipientWishes(address)}
                                        </P>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    {edit &&
                        <div style={{width: '100%', padding: formSpacing.inset}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <H6 style={{marginBottom: 12}}>{(address.isBusiness && address.name) ? address.name : `${address.street} ${address.nr}${address.addition}`}</H6>

                                <div style={{flex: 1}} />

                                <IconButton
                                    icon='mdi mdi-check'
                                    onClick={() => this.editAddress.save()}
                                />
                            </div>

                            <EditAddress
                                address={address}
                                addressBook={addressBook}
                                onSave={this.saveAddress.bind(this)}
                                allowAttachments={true}
                                ref={(ref) => this.editAddress = ref}
                                reseller={reseller}
                            />
                        </div>
                    }
                </Card>

                {error &&
                    <Alert style={{marginBottom: 6}} variant='error'>{error}</Alert>
                }
            </div>

        )
    }
}

export default Address
